// extracted by mini-css-extract-plugin
module.exports = {"container":"transcript-summary__container___3fUj7","buttons":"transcript-summary__buttons___194_b","footer":"transcript-summary__footer___2mygm"};